import React from "react";

import SvgIcon, { classes } from "./SvgIcon";
import { SvgIconProps } from "./types";

const Plus = (props: SvgIconProps) => {
    const { stroke } = classes;

    return (
        <SvgIcon {...props}>
            <line
                x1="12"
                y1="7"
                x2="12"
                y2="17"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                className={stroke}
            />
            <line
                x1="7"
                y1="12"
                x2="17"
                y2="12"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                className={stroke}
            />
        </SvgIcon>
    );
};

export default Plus;
